function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.09985 21C9.09985 21 11.5293 22.4 13.9999 22.4C16.4704 22.4 18.8999 21 18.8999 21",
  stroke: "white",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.3999 16.1001L19.5999 16.1001",
  stroke: "white",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.7999 26.6002L8.3999 11.2002C8.3999 11.2002 11.1999 11.9002 13.9999 11.9002C16.7999 11.9002 19.5999 11.2002 19.5999 11.2002L18.1999 26.6002C18.1999 26.6002 16.0999 27.3002 13.9999 27.3002C11.8999 27.3002 9.7999 26.6002 9.7999 26.6002Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0002 8.3999V1.3999",
  stroke: "white",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0001 1.3999L8.40015 6.9999",
  stroke: "white",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6001 6.9999L14.0001 1.3999",
  stroke: "white",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4001 1.3999H23.4001C23.4001 0.847618 22.9524 0.399902 22.4001 0.399902V1.3999ZM5.6001 1.3999V0.399902C5.04781 0.399902 4.6001 0.847618 4.6001 1.3999L5.6001 1.3999ZM21.4001 1.3999C21.4001 4.60009 18.6349 7.3999 14.0001 7.3999V9.3999C19.4453 9.3999 23.4001 5.9775 23.4001 1.3999H21.4001ZM14.0001 7.3999C9.36529 7.3999 6.6001 4.60009 6.6001 1.3999H4.6001C4.6001 5.9775 8.55491 9.3999 14.0001 9.3999V7.3999ZM5.6001 2.3999H22.4001V0.399902H5.6001V2.3999Z",
  fill: "white"
});

var SvgTequilla = function SvgTequilla(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTequilla, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tequilla.5fbf2e57.svg";
export { ForwardRef as ReactComponent };